import makeApi from '../../libs/axios/api';
import { type CustomerInfo } from '../../types/customerInfo';
const apiPromise = makeApi();

const accountNo = '1145397'; // Replace with the actual account number
const ADD_PATH = `/customer?AccountNo=${accountNo}`;

const getCustomerInfo = async (): Promise<CustomerInfo[]> => {
    const api = await apiPromise;
    return api.get(ADD_PATH).then((response) => {
        return response.data as CustomerInfo[];
    });
}
export default getCustomerInfo